(() => {
  if (window.hoopZeptoCartPreviewLoaded) return;
  window.hoopZeptoCartPreviewLoaded = true;
  const previewLabel = /^(preview|preview image|aperçu|image d’aperçu|image d'aperçu)$/i;
  function enhanceCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    drawer.querySelectorAll('.cart-item').forEach((item) => {
      const previewRow = Array.from(item.querySelectorAll('.product-option')).find((row) => {
        const label = row.querySelector('dt');
        const labelText = label ? label.textContent : row.textContent.split(':')[0];
        return previewLabel.test(labelText.trim().replace(/[:：]$/, '').trim());
      });
      if (!previewRow || ['shown', 'loading'].includes(previewRow.dataset.hoopPreviewState)) return;
      const previewLink = previewRow.querySelector('dd a[href], a[href]');
      const href = previewLink && previewLink.getAttribute('href');
      if (!href || /^(#|javascript:|mailto:|tel:)/i.test(href.trim())) return;
      let imageUrl;
      try { imageUrl = new URL(href.trim(), document.baseURI).href; } catch (_) { return; }
      const imageContainer = item.querySelector('.cart-item__image-container');
      let productImage = item.querySelector('.cart-item__image');
      if (!productImage && imageContainer) {
        productImage = document.createElement('img');
        productImage.className = 'cart-item__image hoop-cart-preview-image';
        productImage.loading = 'eager';
        productImage.decoding = 'async';
        productImage.alt = 'Aperçu personnalisé de la coque';
        imageContainer.appendChild(productImage);
      }
      if (!productImage) return;
      previewRow.dataset.hoopPreviewState = 'loading';
      const originalSrc = productImage.getAttribute('src');
      const originalSrcset = productImage.getAttribute('srcset');
      const restoreProductImage = () => {
        if (originalSrc) productImage.setAttribute('src', originalSrc);
        if (originalSrcset) productImage.setAttribute('srcset', originalSrcset);
        else productImage.removeAttribute('srcset');
        delete previewRow.dataset.hoopPreviewState;
      };
      productImage.loading = 'eager';
      productImage.removeAttribute('srcset');
      productImage.alt = 'Aperçu personnalisé de la coque';
      productImage.onload = () => {
        if (!item.isConnected) return;
        previewRow.hidden = true;
        previewRow.dataset.hoopPreviewState = 'shown';
      };
      productImage.onerror = restoreProductImage;
      productImage.src = imageUrl;
    });
  }
  function initialize() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    enhanceCartDrawer();
    new MutationObserver(enhanceCartDrawer).observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();